import { getCookieChild, ready, setCookie, ifSelectorExist, getElements, getElement, deleteCookie } from "./utils";
import { locationModal } from "./location-modal-window";
import { nextDoorEvent } from "./nextdoor-cf7-event";
import { contactUsSwapAddress } from "./contact-us-swap-address";
import { couponByState } from "./coupons-by-state";
import { cf7RandomizerForId } from "./cf7-randomizer-for-id";

console.log('testing deployment to production');

const COOKIE_VERSION = "1.2"; // Increment this when logic changes
const VERSION_COOKIE_NAME = "cookieVersion";

ready(() => {
  checkAndPurgeCookies();
  locationModal();
  contactUsSwapAddress();
  couponByState();
  cf7RandomizerForId();
});

nextDoorEvent();


// Function to check the version and purge outdated cookies if needed
function checkAndPurgeCookies() {
  console.log('getCookie(VERSION_COOKIE_NAME)', getCookie(VERSION_COOKIE_NAME))
  if (getCookie(VERSION_COOKIE_NAME) !== COOKIE_VERSION) {
    console.log("Cookie version mismatch. Clearing outdated cookies.");

    const cookiesToDelete = [
      "selectedPhone",
      "selectedEmail",
      "selectedState",
      "selectedLabel",
      "selectedCity",
    ];

    cookiesToDelete.forEach(deleteCookie);

    // Update the version cookie
    setCookie(VERSION_COOKIE_NAME, COOKIE_VERSION, 365);
  }
}





document.addEventListener('wpcf7mailsent', function (event) {
  // Check if the form submission is successful and the cookie for selectedCity is Indianapolis
  if (getCookieChild('selectedCity') === 'Indianapolis') {
    // Create the script element
    var pixelScript = document.createElement('script');
    pixelScript.type = 'text/javascript';
    pixelScript.async = true;
    pixelScript.src = "//pixel.admedia.com/w.php?ai=19790&ct=Lead&cv=";

    // Append the script to the body or head
    document.body.appendChild(pixelScript);
  }

  if (getCookieChild('selectedCity') === 'Columbus') {
    // Create the script element
    var pixelScript = document.createElement('script');
    pixelScript.type = 'text/javascript';
    pixelScript.async = true;
    pixelScript.src = "//pixel.admedia.com/w.php?ai=19792&ct=Lead&cv=";

    // Append the script to the body or head
    document.body.appendChild(pixelScript);
  }
}, false);


function setEmailFromCookie(selectedEmail) {
  // If selectedEmail is available, set it to inputs
  if (selectedEmail) {
    const formRecipients = document.querySelectorAll('input.form_recipient');
    if (formRecipients != undefined && formRecipients != null) {
      formRecipients.forEach((inputElement) => {
        inputElement.value = decodeURIComponent(selectedEmail);
      });
    }
  }
}

function populateCF7HiddenFieldsFromCookies() {
  const cookieKeys = [
    'selectedCity',
    'selectedEmail',
    'selectedLabel',
    'selectedPhone',
    'selectedState'
  ];

  // Iterate over each cookie name
  cookieKeys.forEach(cookieKey => {
    const cookieValue = getCookie(cookieKey);
    if (!cookieValue) return;

    // Find all inputs in CF7 forms with matching name
    const inputs = document.querySelectorAll(`form.wpcf7-form input[name="${cookieKey}"]`);

    inputs.forEach(input => {
      input.value = decodeURIComponent(cookieValue);
    });
  });
}

let setDefaultValueForCitySelect = () => {
  // Get the saved city from cookies
  var savedCity = getCookieChild('selectedLabel');

  const headerCityName = getElement('.location-modal-window--open');
  if (ifSelectorExist(headerCityName) && savedCity) {
    headerCityName.textContent = savedCity;
  }

  // If there's a saved city, set it as selected
  if (savedCity) {
    var selectElement = document.getElementById('city-select');
    if (ifSelectorExist(selectElement)) {
      for (var i = 0; i < selectElement.options.length; i++) {
        if (selectElement.options[i].text === savedCity) {
          selectElement.selectedIndex = i;
          break;
        }
      }
    }
  }
}



// Function to replace phone numbers
function replacePhoneNumbers(newPhone) {
  if (newPhone != null && newPhone !== undefined) {
    // Convert new phone to a simple format
    var simpleNewPhone = newPhone.replace(/[^0-9]/g, "");

    // Convert simpleNewPhone to formatted string (317) 680 8033
    var formattedNewPhone = `(${simpleNewPhone.slice(0, 3)}) ${simpleNewPhone.slice(3, 6)} ${simpleNewPhone.slice(6, 10)}`;

    // Fetch all elements with the tag 'a'
    var anchors = document.querySelectorAll("a");

    // Regex for detecting phone numbers
    var formattedOldPhoneRegex = /(\+?1?[-.\s]?(\()?[-.\s]?[0-9]{3}[-.\s]?(\))?[-.\s]?[0-9]{3}[-.\s]?[0-9]{4})/g;

    // Loop through each anchor tag
    anchors.forEach(function (anchor) {
      // Loop through each child node in the anchor
      for (const node of anchor.childNodes) {
        // Check if the node is a text node
        if (node.nodeType === 3) {

          var oldPhoneText = node.nodeValue;

          if (oldPhoneText.match(formattedOldPhoneRegex)) {
            // Replace only the phone number in the text node
            node.nodeValue = oldPhoneText.replace(formattedOldPhoneRegex, formattedNewPhone);
          }
        }
      }

      var oldPhoneHref = anchor.getAttribute("href");
      // Replace in href attribute
      if (oldPhoneHref && oldPhoneHref.match(formattedOldPhoneRegex)) {
        anchor.setAttribute("href", `tel:${formattedNewPhone}`);
      }
    });
  }
}

function replaceKeywordsWithCity(cityName) {
  if (!cityName) {
    return; // Exit if cityName is not set
  }

  const keywords = [
    'around Indianapolis',
    'Bassett’s Indianapolis',
    'chilly Indiana',
    'chilly Plainfield',
    'Cost in Indiana',
    'in Indiana',
    'in Indianapolis at',
    'in Indianapolis, IN',
    'in Indianapolis, Indiana',
    'in Plainfield, IN',
    'in Plainfield, Indiana',
    'Plainfield, Indiana',
    'Indiana home',
    'Indiana’s reputable',
    'Indianapolis Area',
    'Indianapolis, IN',
    'Indianapolis, Indiana',
    'Indianapolis, Indiana’s',
    'info@bassettservices.com',
    'Local Indianapolis',
    'local Indianapolis',
    'my Indianapolis',
    'Near Indianapolis',
    'near Indianapolis',
    'Near Indianapolis, Indiana',
    'near Plainfield, Indiana',
    'of Indianapolis',
    'of Plainfield, Indiana',
    'Plainfield documented',
    'Plainfield experiences',
    'Plainfield hover',
    'Plainfield shivered',
    'Plainfield, IN',
    'Plainfield, Indiana, like',
    'seasoned Indiana',
    'Services in Indiana',
    'Serving Plainfield, IN',
    'skilled Indianapolis',
    'the Indianapolis',
    'the Indianapolis vicinity',
    'the Indianapolis, Indiana Area',
    'to Indianapolis',
    'Trust Indianapolis, Indiana',
    'unforgiving Indiana',
    'West Indiana',
    'why Indianapolis',
    'your Indiana',
    'Your Indianapolis, Indiana',
  ];

  function replaceText(node) {
    let modifiedText = node.nodeValue;

    keywords.forEach((keyword) => {
      // Ensure we replace only whole words and not parts of words
      const regExp = new RegExp(`\\b${keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')}\\b`, 'gi');

      modifiedText = modifiedText.replace(regExp, (match) => {
        return match.replace(/\bPlainfield\b/gi, cityName) // First, replace "Plainfield"
          .replace(/\bIndiana\b/gi, cityName) // Then, replace "Indiana"
          .replace(/\bIndianapolis\b/gi, cityName); // Finally, replace "Indianapolis"
      });
    });

    // Remove unnecessary parts after replacement
    const removableParts = [', IN', ', Indiana', ', Indiana’s', ', Indiana Area'];
    removableParts.forEach((part) => {
      const regExp = new RegExp(`${part.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')}`, 'g');
      modifiedText = modifiedText.replace(regExp, '');
    });

    node.nodeValue = modifiedText;
  }

  function walk(node) {
    if (node.parentNode && node.parentNode.tagName === 'SELECT') {
      return;
    }

    let ancestor = node.parentNode;
    while (ancestor) {
      if (ancestor.classList?.contains('skip-city-replace') || ancestor.classList?.contains('location-modal-window--open')) {
        return;
      }
      ancestor = ancestor.parentNode;
    }

    if (node.nodeType === 3) {
      replaceText(node);
    }

    let child = node.firstChild;
    while (child) {
      walk(child);
      child = child.nextSibling;
    }
  }

  function replaceDuplicateCity(cityName) {
    if (!cityName) {
      return;
    }

    function replaceText(node) {
      const regExp = new RegExp(`\\b${cityName},\\s*${cityName}\\b`, 'gi');
      node.nodeValue = node.nodeValue.replace(regExp, cityName);
    }

    function walk(node) {
      if (node.nodeType === 3) {
        replaceText(node);
      }
      let child = node.firstChild;
      while (child) {
        walk(child);
        child = child.nextSibling;
      }
    }

    walk(document.body);
  }

  function cleanUpMessedUpReplacements(cityName) {
    function replaceText(node) {
      if (!node.nodeValue) return;

      // Fix "Indianapolispolis"
      const duplicateRegExp = new RegExp(`Indianapolispolis`, 'gi');
      node.nodeValue = node.nodeValue.replace(duplicateRegExp, cityName);

      // Ensure spacing around inline HTML elements like <span>
      node.nodeValue = node.nodeValue.replace(/(\S)(<span[^>]*>)/g, '$1 $2');
      node.nodeValue = node.nodeValue.replace(/(<\/span>)(\S)/g, '$1 $2');
    }

    function walk(node) {
      if (node.nodeType === 3) {
        replaceText(node);
      }
      let child = node.firstChild;
      while (child) {
        walk(child);
        child = child.nextSibling;
      }
    }

    walk(document.body);
  }

  // Step 1: Perform primary replacements
  walk(document.body);

  // Step 2: Fix duplicate city name issues
  replaceDuplicateCity(cityName);

  // Step 3: Clean up any residual errors (spacing, duplicate names)
  cleanUpMessedUpReplacements(cityName);
}

let installThePixel = (selectedCity) => {

  console.log('installThePixel == ', selectedCity)
  let head = document.querySelector('#site-head');
  var pixelScript = document.createElement('script');
  pixelScript.type = 'text/javascript';
  pixelScript.async = true;

  switch (selectedCity) {
    case 'Indianapolis':
      pixelScript.src = "//pixel.admedia.com/w.php?ai=19790&ct=Lead&cv=";
      document.body.appendChild(pixelScript);

      // First Nextdoor Pixel Code
      var nextdoorScript1 = document.createElement('script');
      nextdoorScript1.type = 'text/javascript';
      nextdoorScript1.innerHTML = `
        (function(win, doc, sdk_url){
          if(win.ndp) return;
          var tr=win.ndp=function(){
            tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
          };
          tr.queue = [];
          var s='script';
          var new_script_section=doc.createElement(s);
          new_script_section.async=!0;
          new_script_section.src=sdk_url;
          var insert_pos=doc.getElementsByTagName(s)[0];
          insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
        })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
        
        ndp('init','3ad23803-3e4a-41a1-a11e-f97ca59d5533', {});
        ndp('track','PAGE_VIEW');
      `;
      head.appendChild(nextdoorScript1);

      var noscript1 = document.createElement('noscript');
      var noscript1Img = document.createElement('img');
      noscript1Img.height = "1";
      noscript1Img.width = "1";
      noscript1Img.style.display = "none";
      noscript1Img.src = "https://flask.nextdoor.com/pixel?pid=3ad23803-3e4a-41a1-a11e-f97ca59d5533&ev=PAGE_VIEW&noscript=1";
      noscript1.appendChild(noscript1Img);
      head.appendChild(noscript1);

      // Second Nextdoor Pixel Code
      var nextdoorScript2 = document.createElement('script');
      nextdoorScript2.type = 'text/javascript';
      nextdoorScript2.innerHTML = `
        (function(win, doc, sdk_url){
          if(win.ndp) return;
          var tr=win.ndp=function(){
            tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
          };
          tr.queue = [];
          var s='script';
          var new_script_section=doc.createElement(s);
          new_script_section.async=!0;
          new_script_section.src=sdk_url;
          var insert_pos=doc.getElementsByTagName(s)[0];
          insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
        })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
        
        ndp('init','6d585239-6130-4772-8722-0ba85337b160', {});
        ndp('track','PAGE_VIEW');
      `;
      head.appendChild(nextdoorScript2);

      var noscript2 = document.createElement('noscript');
      var noscript2Img = document.createElement('img');
      noscript2Img.height = "1";
      noscript2Img.width = "1";
      noscript2Img.style.display = "none";
      noscript2Img.src = "https://flask.nextdoor.com/pixel?pid=6d585239-6130-4772-8722-0ba85337b160&ev=PAGE_VIEW&noscript=1";
      noscript2.appendChild(noscript2Img);
      head.appendChild(noscript2);

      break;
      pixelScript.src = "//pixel.admedia.com/w.php?ai=19790&ct=Lead&cv=";
      document.body.appendChild(pixelScript);

      var nextdoorScript1 = document.createElement('script');
      nextdoorScript1.type = 'text/javascript';
      nextdoorScript1.innerHTML = `
          (function(win, doc, sdk_url){
            if(win.ndp) return;
            var tr=win.ndp=function(){
              tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
            };
            tr.queue = [];
            var s='script';
            var new_script_section=doc.createElement(s);
            new_script_section.async=!0;
            new_script_section.src=sdk_url;
            var insert_pos=doc.getElementsByTagName(s)[0];
            insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
          })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
          
          ndp('init','3ad23803-3e4a-41a1-a11e-f97ca59d5533', {});
          ndp('track','PAGE_VIEW');
        `;
      head.appendChild(nextdoorScript1);

      var noscript1 = document.createElement('noscript');
      var noscript1Img = document.createElement('img');
      noscript1Img.height = "1";
      noscript1Img.width = "1";
      noscript1Img.style.display = "none";
      noscript1Img.src = "https://flask.nextdoor.com/pixel?pid=3ad23803-3e4a-41a1-a11e-f97ca59d5533&ev=PAGE_VIEW&noscript=1";
      noscript1.appendChild(noscript1Img);
      head.appendChild(noscript1);
      break;
    case 'Columbus':
      pixelScript.src = "//pixel.admedia.com/w.php?ai=19792&ct=Lead&cv=";
      document.body.appendChild(pixelScript);

      var additionalScript = document.createElement('script');
      additionalScript.type = 'text/javascript';
      additionalScript.src = "https://a.remarketstats.com/px/smart/?c=260a7915d14c867";
      document.body.appendChild(additionalScript);
      break;
    case 'Cincinnati':
      pixelScript.src = "//pixel.admedia.com/w.php?ai=20250&ct=Lead&cv=";
      document.body.appendChild(pixelScript);
      break;
    // Add more cases as needed for other cities
    default:
      console.log('City not recognized or no action required for the selected city.');
  }
}


function updateBookingLinks(city) {
  const schedulerMap = {
    'Indianapolis': 'sched_ui24s0dbwqsj1gtoksxt7jev',
    'Dayton': 'sched_dstkwwys8pqav0e255253zzw',
    'Cincinnati': 'sched_dstkwwys8pqav0e255253zzw',
    'Columbus': 'sched_lj8yu4vrqbxgik88tc85joiy',
  };

  const schedulerId = schedulerMap[city] || schedulerMap['Indianapolis'];

  const links = document.querySelectorAll('a[onclick="ScheduleEngine.show()"]');
  links.forEach(link => {
    link.setAttribute('onclick', `_scheduler.show({ schedulerId: '${schedulerId}' })`);
  });
}

function insertSchedulerBasedOnCity(city) {
  window.localStorage.setItem('se_debug', 'true');

  const scriptConfig = {
    'Dayton': {
      apiKey: 'xr2lieeisn8wfmq25i8pm2uj',
      schedulerId: 'sched_dstkwwys8pqav0e255253zzw',
    },
    'Cincinnati': {
      apiKey: 'xr2lieeisn8wfmq25i8pm2uj',
      schedulerId: 'sched_dstkwwys8pqav0e255253zzw',
    },
    'Columbus': {
      apiKey: 'ywp0cmtw0aobsk1ikik5r2tu',
      schedulerId: 'sched_lj8yu4vrqbxgik88tc85joiy',
    }
  };

  const config = scriptConfig[city];
  if (!config) return;

  // Remove existing scheduler script if present
  const existingScript = document.querySelector('#se-widget-embed');
  if (existingScript) {
    existingScript.remove();
  }

  // Inject the new scheduler script
  const schedulerScript = document.createElement('script');
  schedulerScript.setAttribute('data-api-key', config.apiKey);
  schedulerScript.setAttribute('data-schedulerid', config.schedulerId);
  schedulerScript.setAttribute('id', 'se-widget-embed');
  schedulerScript.src = 'https://embed.scheduler.servicetitan.com/scheduler-v1.js';

  document.body.appendChild(schedulerScript);
}

// Get the selected phone from cookies
let selectedCity = getCookieChild('selectedCity');
let selectedPhone = getCookieChild('selectedPhone');
let selectedEmail = getCookieChild('selectedEmail');
let selectedState = getCookieChild('selectedState');
let selectedLabel = getCookieChild('selectedLabel');

// it should be called before DOM content ready
insertSchedulerBasedOnCity(selectedCity);
updateBookingLinks(selectedCity);

if (!selectedCity || !selectedPhone || !selectedEmail) {
  let headTag = document.getElementById('site-head');
  if (headTag) {
    let headCity = headTag.getAttribute('data-location');
    let headPhone = headTag.getAttribute('data-phone');
    let headEmail = headTag.getAttribute('data-email');
    let headState = headTag.getAttribute('data-state');
    let headLabel = headTag.getAttribute('data-label');

    if (!selectedCity && headCity) {
      setCookie('selectedCity', headCity, 3);
      selectedCity = headCity;
    }
    if (!selectedPhone && headPhone) {
      setCookie('selectedPhone', headPhone, 3);
      selectedPhone = headPhone;
    }
    if (!selectedEmail && headEmail) {
      setCookie('selectedEmail', headEmail, 3);
      selectedEmail = headEmail;
    }

    if (!selectedState && headState) {
      setCookie('selectedState', headState, 3);
      selectedState = headState;
    }


    if (!selectedLabel && headLabel) {
      setCookie('selectedLabel', headLabel, 3);
      selectedLabel = headLabel;
    }
  }
}


// Function to replace city in the DOM
const replaceCityInShortcodes = (city) => {
  const cityElements = document.querySelectorAll('.cookie_city_swapper');
  cityElements.forEach((element) => {
    element.textContent = city;
  });
};

// Function to replace state in the DOM
const replaceStateInShortcodes = (state) => {

  const stateAbbreviations = {
    "Alabama": "AL",
    "Alaska": "AK",
    "Arizona": "AZ",
    "Arkansas": "AR",
    "California": "CA",
    "Colorado": "CO",
    "Connecticut": "CT",
    "Delaware": "DE",
    "Florida": "FL",
    "Georgia": "GA",
    "Hawaii": "HI",
    "Idaho": "ID",
    "Illinois": "IL",
    "Indiana": "IN",
    "Iowa": "IA",
    "Kansas": "KS",
    "Kentucky": "KY",
    "Louisiana": "LA",
    "Maine": "ME",
    "Maryland": "MD",
    "Massachusetts": "MA",
    "Michigan": "MI",
    "Minnesota": "MN",
    "Mississippi": "MS",
    "Missouri": "MO",
    "Montana": "MT",
    "Nebraska": "NE",
    "Nevada": "NV",
    "New Hampshire": "NH",
    "New Jersey": "NJ",
    "New Mexico": "NM",
    "New York": "NY",
    "North Carolina": "NC",
    "North Dakota": "ND",
    "Ohio": "OH",
    "Oklahoma": "OK",
    "Oregon": "OR",
    "Pennsylvania": "PA",
    "Rhode Island": "RI",
    "South Carolina": "SC",
    "South Dakota": "SD",
    "Tennessee": "TN",
    "Texas": "TX",
    "Utah": "UT",
    "Vermont": "VT",
    "Virginia": "VA",
    "Washington": "WA",
    "West Virginia": "WV",
    "Wisconsin": "WI",
    "Wyoming": "WY"
  };

  const stateElements = document.querySelectorAll(".cookie_state_swapper");

  stateElements.forEach((element) => {
    let stateText = state;

    stateFormat = element.getAttribute('data-format');

    // If format is "short", replace with the state abbreviation
    if (stateFormat == 'short') {
      stateText = stateAbbreviations[state] || state;
    }

    element.textContent = stateText;
  });
};

export let citySelectEvent = () => {

  // Listen for the change event on the select box
  if (ifSelectorExist(document.getElementById('city-select'))) {
    document.getElementById('city-select').addEventListener('change', function () {
      // Get the selected option
      var selectedOption = this.options[this.selectedIndex];

      // Get the data attributes
      var city = selectedOption.getAttribute('data-city');
      setCookie('selectedCity', city, 3);

      var phone = selectedOption.getAttribute('data-phone');
      var email = selectedOption.getAttribute('data-email');
      var state = selectedOption.getAttribute('data-state');
      var label = selectedOption.getAttribute('data-label');

      replacePhoneNumbers(phone);
      setEmailFromCookie(email);
      populateCF7HiddenFieldsFromCookies();
      replaceKeywordsWithCity(city);

      // Set cookies
      setCookie('selectedPhone', phone, 3);
      setCookie('selectedEmail', email, 3);
      setCookie('selectedState', state, 3);
      setCookie('selectedLabel', label, 3);

    });
  }
}
installThePixel(selectedCity);


const noPhoneSwap = getElement('body').classList.contains('no-phone-swap');
if (!noPhoneSwap) {
  document.addEventListener('DOMContentLoaded', function (event) {
    setDefaultValueForCitySelect();

    // If there's a selected phone, replace all phone numbers on the page
    if (selectedPhone) {
      replacePhoneNumbers(selectedPhone);
    }

    if (selectedEmail) {
      setEmailFromCookie(selectedEmail);
    }

    populateCF7HiddenFieldsFromCookies();

    citySelectEvent();
    replaceKeywordsWithCity(selectedCity);

    const defaultCity = 'Indianapolis';
    const defaultState = 'Indiana, IN';

    // Get cookies
    const savedCity = getCookie('selectedCity') || defaultCity;
    const savedState = getCookie('selectedState') || defaultState;


    // Replace placeholders with default or cookie values
    replaceCityInShortcodes(savedCity);
    replaceStateInShortcodes(savedState);
  });
}


// Function to load the Nextdoor Pixel Codes
function loadNextdoorPixelCodes() {
  var head = document.getElementsByTagName('head')[0];
  console.log('nextdoor pixel events on cf7 submit');
  // First Nextdoor Pixel Code
  var nextdoorScript1 = document.createElement('script');
  nextdoorScript1.type = 'text/javascript';
  nextdoorScript1.innerHTML = `
    (function(win, doc, sdk_url){
      if(win.ndp) return;
      var tr=win.ndp=function(){
        tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
      };
      tr.queue = [];
      var s='script';
      var new_script_section=doc.createElement(s);
      new_script_section.async=!0;
      new_script_section.src=sdk_url;
      var insert_pos=doc.getElementsByTagName(s)[0];
      insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
    })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
    
    ndp('init','3ad23803-3e4a-41a1-a11e-f97ca59d5533', {});
    ndp('track','CONVERSION');
  `;
  head.appendChild(nextdoorScript1);

  var noscript1 = document.createElement('noscript');
  var noscript1Img = document.createElement('img');
  noscript1Img.height = "1";
  noscript1Img.width = "1";
  noscript1Img.style.display = "none";
  noscript1Img.src = "https://flask.nextdoor.com/pixel?pid=3ad23803-3e4a-41a1-a11e-f97ca59d5533&ev=CONVERSION&noscript=1";
  noscript1.appendChild(noscript1Img);
  head.appendChild(noscript1);

  // Second Nextdoor Pixel Code
  var nextdoorScript2 = document.createElement('script');
  nextdoorScript2.type = 'text/javascript';
  nextdoorScript2.innerHTML = `
    (function(win, doc, sdk_url){
      if(win.ndp) return;
      var tr=win.ndp=function(){
        tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments);
      };
      tr.queue = [];
      var s='script';
      var new_script_section=doc.createElement(s);
      new_script_section.async=!0;
      new_script_section.src=sdk_url;
      var insert_pos=doc.getElementsByTagName(s)[0];
      insert_pos.parentNode.insertBefore(new_script_section, insert_pos);
    })(window, document, 'https://ads.nextdoor.com/public/pixel/ndp.js');
    
    ndp('init','6d585239-6130-4772-8722-0ba85337b160', {});
    ndp('track','CONVERSION');
  `;
  head.appendChild(nextdoorScript2);

  var noscript2 = document.createElement('noscript');
  var noscript2Img = document.createElement('img');
  noscript2Img.height = "1";
  noscript2Img.width = "1";
  noscript2Img.style.display = "none";
  noscript2Img.src = "https://flask.nextdoor.com/pixel?pid=6d585239-6130-4772-8722-0ba85337b160&ev=CONVERSION&noscript=1";
  noscript2.appendChild(noscript2Img);
  head.appendChild(noscript2);
}

// Event listener for Contact Form 7 submission
document.addEventListener('wpcf7mailsent', function (event) {
  if (getCookie('selectedCity') === 'Indianapolis') {
    loadNextdoorPixelCodes();
  }
}, false);


